export default {
  lang: 'Inglês',
  homeScreen: {
    title: 'ALIMENTE SEUS SONHOS',
    stayConnected: 'Fique conectado:',
    download: 'Baixar',
  },
  notification: {
    newAndNow: 'Novidades!',
    alert: 'Alerta',
    message: 'Mensagem',
    contest: 'Concurso',
    badge: 'Novo Distintivo',
    'content-update': 'Atualização de Conteúdo',
    events: 'Eventos',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos ver se conseguimos encontrar um perfil para si no nosso sistema.',
      homeTitleSub:
        'Introduza o endereço de correio eletrónico que utiliza habitualmente para iniciar sessão nos programas de formação.',
      noAccount:
        'Não foi encontrada nenhuma conta ({email}), tente com outro e-mail ou crie uma conta agora.',
      continueButton: 'Continuar',
      success:
        'Atualização bem sucedida da sua conta! Em breve será redireccionado para a página inicial.',
      successNewAccount:
        'Para concluir o seu registo, receberá um e-mail de confirmação para verificar a sua conta.',
      loginButton: 'Iniciar sessão',
      matchFound:
        'Encontrámos uma correspondência, por favor preencha a sua palavra-passe para continuar.',
      magicLink:
        'Inicie sessão através de uma ligação no seu correio eletrónico:',
      magicLinkButton: 'Pedir Magic Link',
      magicLinkTitle:
        'Receba um link direto enviado para o seu e-mail que o inscreverá instantaneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Reserve um momento para preencher todas as informações abaixo, uma vez que estas preencherão o seu perfil pessoal e as informações de contacto.',
      titleIndustry:
        'Reserve um momento para preencher todas as informações abaixo, uma vez que estas preencherão o seu perfil pessoal e as informações de contacto.',
      register: 'Criar uma conta',
      agent: 'Consultor de viagens',
      visitor: 'Visitante do sector',
      step1: 'Etapa 1: Tipo de utilizador',
      step2: 'Passo 2: Criar uma conta',
      step3: 'Passo 3: Criar o seu perfil',
      marketingOptIn:
        'Tem a certeza de que não está interessado em manter-se ligado à equipa de comércio de viagens deste programa?',
      optIn: 'Sim, estou interessado',
      optOut: 'Não estou interessado',
      step2Sub1: 'Fale-nos de si',
      step2Sub2: 'Fale-nos do seu negócio',
      privacyHead: 'PREFERÊNCIAS DE COMUNICAÇÃO',
      privacySub:
        'Assinale as caixas abaixo para garantir que recebe comunicações importantes da equipa de comércio de viagens do fornecedor (actualizações e anúncios de produtos, recompensas, incentivos, FAMs, etc.) e iniciativas de apoio às vendas e redes de comércio de viagens da TravPRO Mobile.',
      privacy:
        'Protegemos a sua privacidade e nunca vendemos, utilizamos indevidamente ou traímos a sua confiança.',
      store: 'Descarregue facilmente este programa na sua loja de aplicações:',
      powered: 'POTENCIADO POR',
      toastMessage: {
        forgotSuccess:
          'Enviámos por e-mail a sua ligação para redefinição da palavra-passe! Será redireccionado para a página de início de sessão dentro de 10 segundos.',
        emailNotExisting:
          'O endereço de correio eletrónico que introduziu não existe.',
        magicLinkMessage: 'Aguarde, estamos a registá-lo neste momento.',
        magicLinkError:
          'Não foi possível encontrar a sua conta na nossa base de dados. Inicie sessão manualmente. Será redireccionado em 10 segundos.',
        magicLinkError1:
          'Não foi possível encontrar um token válido. Inicie sessão ou solicite uma nova ligação mágica. Se o problema persistir, contacte-nos em: info@travpromobile.com.',
        magicLinkError2:
          'Não foi possível encontrar a sua conta na nossa base de dados. Inicie sessão manualmente. Será redireccionado em 10 segundos.',
        magicLinkSuccess:
          'Verifique o seu e-mail em {email}. Tem uma hiperligação mágica que o vai registar.',
        magicLinkErrorWait:
          'Aguarde 5 minutos entre pedidos de ligações mágicas.',
        emailNotFoundError:
          'O endereço de correio eletrónico que introduziu não se encontra nos nossos registos. Verifique se há erros ortográficos ou crie uma conta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal não encontrado, tente novamente',
        zipCodeOnlyNumbers: 'O ZipCode só pode conter números',
        password: 'Introduzir uma palavra-passe',
        passwordNotMatching: 'As palavras-passe introduzidas não correspondem',
        passwordTooShort: 'A palavra-passe tem de ter pelo menos 8 caracteres',
        emailExists:
          'Este endereço de correio eletrónico já existe ou é inválido. Tente com outro endereço de correio eletrónico ou inicie sessão na sua conta.',
        fillInAllFields: 'Preencher todos os campos obrigatórios',
        fillInEmail: 'Preencha o seu e-mail.',
        emailNotExisting:
          'O endereço de correio eletrónico que introduziu não existe.',
      },
      fields: {
        forgotSubCopy:
          'Esqueceu-se da sua palavra-passe e pretende alterá-la? ',
        forgotSubCopy2:
          'Pretende ignorar totalmente a palavra-passe? Enviar-lhe-emos um e-mail com uma ligação mágica que o ligará automaticamente ao programa.',
        city: 'Cidade',
        companyName: 'Nome da empresa',
        role: 'O seu papel',
        description: 'Qual descreve melhor a atividade da sua empresa?',
        country: 'País',
        password: 'Palavra-passe',
        passwordRegister: 'Escolha a palavra-passe (mínimo de 8 caracteres)',
        passwordConfirm: 'Confirmar a palavra-passe',
        firstName: 'Nome próprio',
        lastName: 'Apelido (Família)',
        agency: 'Nome da sua agência',
        title: 'A sua função (selecionar uma)',
        company: 'Nome da empresa',
        select: 'Seleccione uma opção abaixo',
        state: 'Estado',
        province: 'Província/Região/Estado',
        zipCode: 'Código Postal',
        postalCode: 'Código Postal',
        affiliate: 'A que grupo pertence a sua agência PRINCIPAL?',
        hostAgency: 'A sua agência de acolhimento?',
        executive: 'Executivo',
        management: 'Gestão',
        marketing: 'Marketing',
        sales: 'Vendas',
        coordinator: 'Coordenador',
        opt: 'Mantenha-se ligado à equipa de comércio de viagens deste programa e receba actualizações.',
        optMarketing:
          'Mantenha-se em contacto com a TravPRO relativamente a programas e eventos semelhantes.',
        retail: 'Frente de loja de retalho',
        home: 'Agente domiciliário',
        independent: 'Contratante independente',
        host: 'Agência de acolhimento',
        call: 'Call Center ou agência baseada na Web',
        other: 'Outros',
        describes: 'O que melhor descreve a sua atividade e a da sua agência?',
      },
    },
    title: 'Programa de Capacitação em Vendas e Treinamento Profissional',
    welcome: {
      headerTop: 'Bem-vindo ao',
      headerBottom: 'Guia de Vendas Visit California da California STAR. ',
    },
    sellingPoints: [
      'Recurso de Conversão de Vendas Diárias',
      'Apresentações e Descobertas de Alto Impacto',
      "Personalize com pasta 'favoritos'",
      'Online, offline - a qualquer hora, em qualquer lugar',
      'Compartilhe, Conecte, Converta',
    ],
    emailPrompt:
      'Digite seu endereço de e-mail para confirmar que você é um profissional de viagens.',
    tAndC: {
      agree: 'Ao continuar você concorda com nossa ',
      privacyPolicy: 'política de privacidade',
      and: ' e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      agency: 'Agência',
      email: 'E-mail',
      firstName: 'Primeiro Nome',
      lastName: 'Sobrenome',
      agencyName: 'Nome da agência',
      stateProvince: 'Estado / Província',
      registrationCode: 'Código promocional (opcional)',
      required: 'Obrigatório',
      invalidEmail: 'Endereço de e-mail inválido',
      opt: 'Manter contato! Sim, gostaria de participar de comunicações da Visit California que me manterão informado sobre notícias, eventos, incentivos, FAMs e muito mais!',
      forgot:
        'Esqueceu-se da sua palavra-passe? Clique no botão abaixo e enviar-lhe-emos um e-mail para redefinir a sua palavra-passe.',
    },
    forgot: 'Repor a palavra-passe',
    noAgent: {
      noAgentButton: 'Não sou um conselheiro',
      title: 'Obrigado por seu interesse na California STAR.',
      messageWeb:
        'O conteúdo deste site é exclusivo para profissionais de viagens. \n Para saber mais sobre California STAR, visite: ',
      messageMobile:
        "Alguns conteúdos deste aplicativo são exclusivos para profissionais de viagens, mas fique à vontade para navegar por uma amostra do que este aplicativo tem a oferecer pressionando 'Continuar'.",
      continue: 'Continue',
      visitWebsite: 'Visitar site >',
    },
    newUser: 'Novo usuário',
    register: 'Registre-se',
  },
  welcomeScreen: {
    title:
      'Bem-vindo ao\nPrograma de Treinamento e Guia de Vendas California STAR ',
    helloUser: 'Olá {name}',
    hello: 'Olá,',
    fromAgency: 'de {agency}',
    notUser: 'Não é {name}?',
    introOnline:
      'Treine imediatamente on-line ou pré-carregue o conteúdo para que ele esteja sempre disponível para uso off-line!',
    introOffline:
      'Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer hora, em qualquer lugar!',
    startTraining: 'Comece a treinar',
    downloader: {
      preload: 'Pré-carregamento',
      stop: 'Parar',
      init: 'Inicializando ...',
      lastUpdate: 'Última atualização: ',
    },
  },
  trainingScreens: {
    allUnlocked: 'Você desbloqueou todos os capítulos!',
    certificate: 'Certificado',
    chapter: 'Capítulo',
    chapterComplete: 'Capítulo completo!',
    choose: 'Por favor, escolha uma resposta',
    confirm: 'Confirme sua resposta',
    continue: 'Continuar',
    welcome:
      'Bem-vindo à nossa seção de Treinamento redesenhada! Complete os módulos para ganhar pontos em direção ao seu objetivo final de se tornar um CA STAR Ouro. A barra à direita mostrará exatamente como você está indo.',
    courseComplete: 'Curso Completo!',
    durationInMinutes: '{number} minutos',
    endReached: 'Você chegou ao fim',
    essential: 'Módulos Essenciais',
    essentialSub:
      'Conclua esses módulos para ganhar o status de CA STAR Bronze',
    message: '{count} Mensagem STAR',
    messagePlural: '{count} Mensagens STAR',
    percentageComplete: '{number}% Completo',
    restart: 'Reiniciar',
    retainEnd:
      'Use a barra superior para navegar por este capítulo ou pressione o botão de voltar para retornar à visão geral.',
    retry: 'Tentar Novamente',
    review: 'Revisar',
    skip: 'Pular questão',
    specialization: 'Módulos de Especialização',
    specializationSub:
      'Conclua esses módulos para alcançar o status de CA STAR Prata',
    start: 'Iniciar',
    status: 'Status Atual:',
    tip: 'Você ganha seu status ao completar<br />os módulos dentro de cada nível. <br />Sonhe grande e alcance o status de CA STAR Ouro<br />completando todos os módulos!',
    trouble:
      'Parece que você está tendo dificuldades, gostaria de pular esta questão?',
    unlock:
      'Desbloqueie este capítulo completando o capítulo de treinamento {number}.',
    unlockSpecialization: 'Desbloqueie este capítulo completando A Fundação',
    unlockSubtitle:
      'Desbloqueie mais capítulos completando capítulos de treinamento.',
    watchListenRead: 'Assista, Ouça e Leia mais',
  },
  nav: {
    home: 'Início',
    train: 'Trem',
    retain: 'Retenção',
    directory: 'Diretório',
    promote: 'Promover',
    sell: 'Venda',
    info: 'Info',
    media: 'Mídia',
    favorites: 'Favoritos',
    contact: 'Contato',
    reportCard: 'Boletim',
    accountSettings: 'Configurações de conta',
    messages: 'Mensagem STAR',
    search: 'Buscar',
    showcases: 'Vitrinas',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Biblioteca de treinamento',
    retain: 'Reter',
    subapps: 'Mini Treinamento de Parceiro California',
    maintrainings: 'A Fundação',
    subtrainings: 'A Experiência',
  },
  pageDescriptions: {
    train: 'Eduque, envolva-se e torne-se um especialista.',
    retain:
      'Reter permite explorar todo o conteúdo para reforçar seu conhecimento deste destino diversificado.',
    promote:
      'Acesso fácil ao Material Promocional Compartilhável e ao Fale Conosco.',
    sell: 'Todos os ativos de mídia e materiais de vendas organizados para fácil acesso e compartilhamento.',
    favorites: 'Confira seu conteúdo favorito individual',
    search: 'Ver todo o conteúdo',
    subapps: 'Saiba mais dos nossos parceiros',
    maintrainings:
      'Conclua esses capítulos essenciais para alcançar o status BRONZE e ganhar seu diploma!',
    subtrainings:
      'Ganhe um distintivo ao concluir cada experiência especializada abaixo.',
  },
  general: {
    showcase: 'Showcases',
    next: 'Próximo',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar ',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Entrar',
    logOut: 'Sair',
    viewItem: 'Visualização',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Nenhum resultado foi encontrado para: {query}',
    noFavorites: 'Você não tem favoritos ainda.',
    noMessages: 'Você ainda não tem mensagens!',
    resultsFor: 'Resultados para: {query}',
    showAll: 'Mostrar tudo',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: '404 Página Não Encontrada!',
    oops: 'Oh, não!',
    overview: 'Retornar à visão geral',
    complete: 'Curso Concluído!',
    share: 'Compartilhar',
    destinations: 'Mini Treinamento de Parceiro California',
    essentials: 'California Essentials',
    trainingLibrary: 'Biblioteca de treinamento',
    message: '{count} Mensagem STAR',
    messagePlural: '{count} Mensagem STAR',
    badge: 'Distintivo',
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Site',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os mostradores para corresponder à resposta',
    fitb: 'Preencha os espaços em branco',
    flip: 'Altere o número para corresponder à resposta',
    multipleChoice: 'Escolha a(s) resposta(s) correta(s)',
    slider: 'Escolha a resposta certa usando a barra deslizante',
    map: 'Responda a pergunta tocando no local correto no mapa',
    dropdown: 'Escolher...',
    true: 'Verdadeiro',
    false: 'Falso',
  },
  cookies: {
    consent: 'CONCORDAR',
    optout: 'Excluir',
    settings: 'Configurações de privacidade',
    message:
      'Você não nos contou sobre suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a você a melhor experiência com o Guia de Vendas.',
    disabled: 'Parece que você desativou o uso de cookies.',
    use: 'O {appName} exige o uso de cookies para proporcionar a melhor experiência.',
    details: 'Para que servem os cookies?',
    enable: 'Veja como ativar seus cookies {here}.',
    here: 'Aqui',
  },
  notLoggedIn: {
    super: 'Você não está logado',
    title: 'Você precisa estar logado para ver este conteúdo',
    guest: 'Visitante',
  },
  demo: {
    message:
      'Este site é uma demonstração do produto final. Atualmente está em desenvolvimento e não é um produto completo.',
    consent: 'Entendi!',
  },
  share: {
    header: 'Compartilhe este recurso em sua rede social favorita!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que você está tentando acessar o aplicativo {appName} de um dispositivo móvel',
    body: 'Para baixar esse programa, basta visitar sua loja de aplicativos e buscar por {appName} ou clicar em um dos botões abaixo',
    benefits: {
      header: 'Isso proporcionará a você:',
      1: 'Portabilidade',
      2: 'Não há necessidade de WiFi, treine quando e onde for conveniente',
      3: 'Ferramentas e recursos de vendas ao seu alcance',
    },
  },
  sharing: {
    twitter: 'Considere tirar suas próximas férias na California...',
    imageEmailSubject: 'Só para você, da California STAR... Ideias de Férias',
    imageEmailCopy:
      'Reserve um minuto para analisar o conteúdo de férias da California STAR anexo… Divirta-se!',
    videoEmailSubject:
      'Ótimas ideias de férias California STAR sendo compartilhadas com você!',
    videoEmailCopy:
      'Achei que você gostaria deste vídeo de férias da California STAR. Basta clicar no link abaixo para assistir.  Divirta-se!',
    infographicEmailSubject:
      'Compartilhando algo sobre as ideias de férias da California STAR...',
    infographicEmailCopy:
      'Achei que isso lhe interessaria, tire um minuto para ver o conteúdo anexo.   Até logo!',
  },
  newTrainingFlow: {
    tip: 'Você obtém seu status concluindo os módulos em cada camada.  Sonhe alto e alcance o status de Ouro de CA STAR ao concluir todos os módulos!',
    essentialModules: 'Módulos Essenciais',
    finishBronze:
      'Conclua esses módulos para obter Seu Status de Bronze de CA STAR',
    specializationModules: 'Módulos de Especialização',
    finishSilver:
      'Conclua esses módulos para obter Seu Status de Prata de CA STAR',
    partnerModules: 'Módulos de parceiros',
    finishGold: 'Conclua esses módulos para obter Seu Status Dourado CA STAR',
    currentStatus: 'Status atual',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'até você atingir o ranking {rank}!',
    outOf: '{points} XP a partir de',
    pointsToRank: '{pointsToLevel}  XP necessário para classificar:  ({rank})',
  },
  points: {
    pointsToLevel:
      '{pointsToLevel} {points} até alcançar a classificação {rank}!',
    outOf: '{points} XP de',
    unit: 'XP',
    pointsToRank: '{pointsToLevel}XP necessário para classificação: ({rank})',
    complete: {
      chapter: 'Capítulo completo!',
      'intro-chapter': 'Capítulo de Introdução completo!',
      'sub-app': 'SubApp completo!',
      rewards: 'Recompensas completas!',
      multi: 'Você merece alguns pontos!',
    },
    completed: '{completed} / {total} Completados',
  },
  new: {
    achievements: 'Conquistas',
  },
  badgeView: {
    title: 'Conquistas de treinamento',
    subtitle:
      'Bem-vindo ao painel Achievements (Conquistas), onde você pode visualizar, acompanhar e fazer download de seus diplomas e distintivos de especialização.',
    badgeDisplayTitle: 'Status de conquista metálica',
    badgeAchievement:
      'Você alcançou o status {rank}! Clique no ícone à direita para visualizar e compartilhar seu status.',
    bronze: 'Bronze',
    silver: 'Prata',
    gold: 'Ouro',
    platinum: 'Platina',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Distintivos de especialização',
    partnerBadges: 'Distintivos de parceiros',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
